<template>
  <div class="d-none d-lg-block">
    <li class="dropdown nav-item" v-if="help_list.length > 0">
      <a
        href="#"
        class="dropdown-toggle nav-link text-nowrap"
        data-toggle="dropdown"
      >
        <i class="fa fa-question-circle"></i>
      </a>
      <div class="dropdown-menu dropdown-with-icons">
        <a
          href="#"
          class="dropdown-item"
          v-for="(help, i) in help_list"
          :key="'help' + i"
          @click="show_help(help)"
        >
          {{ $t("message.help." + help) }}
        </a>
      </div>
    </li>
    <b-modal
      id="modal-help"
      size="xl"
      :title="$t('message.help.' + current_help)"
      :hide-footer="true"
    >
      <div class="embed-responsive embed-responsive-21by9">
        <video controls="controls">
          <source :src="'/videos/' + current_help + '.mp4'" />
        </video>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["page"],
  data() {
    return {
      current_help: "",
    };
  },
  methods: {
    show_help(help) {
      this.current_help = help;
      this.$bvModal.show("modal-help");
    },
  },
  computed: {
    baseurl() {
      return window.base;
    },
    help_list() {
      let result = [];
      switch (this.page) {
        case "home":
        case "sign-up":
        case "sing-in":
          result.push("registration");
          break;
        case "comply-advantage-index":
          result.push("ca");
          break;
        case "contracts-index":
          result.push("contract-new");
          result.push("document");
          result.push("transport_offer");
          result.push("contract_add_contragent");
          result.push("new_contract");
          result.push("contract_signature");
          result.push("contract_offer");
          result.push("export_import");
          result.push("epi");
          break;
        case "account":
          result.push("pa_personal");
          result.push("pa_legal");
          break;
        case "find-a-partner-index":
          result.push("contragent_check");
          break;
        case "contragents-search-index":
          result.push("china-search");
          break;
      }
      return result;
    },
  },
};
</script>
